module.exports = __webpack_public_path__ + "static/media/github-logo.a6a77385.svg";